import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.199 7.803a.994.994 0 01-1.406 1.406L5 6.406 2.197 9.21A.994.994 0 11.791 7.803L3.594 5.01.8 2.197A.994.994 0 112.207.791L5.01 3.594 7.803.79a.994.994 0 111.406 1.406L6.406 5 9.21 7.793l-.01.01z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
